import { themeUi } from '../../themeUi/themeUi';

export const vectorSearch = {
  container: {
    backgroundColor: themeUi.semantic.color.background.secondary100
  },
  featureCard: {
    backgroundColor: themeUi.semantic.color.background.secondary0,
    borderColor: themeUi.semantic.color.border.secondary300,
    boxShadow: themeUi.core.shadow.shadow4
  },
  footerLinks: {
    color: themeUi.semantic.color.text.neutral600
  }
};
